import { ConnectionState } from '../types/auth'

export const getConnectionTextByState = (connectionState: ConnectionState) => {
  switch (connectionState) {
    case ConnectionState.connecting:
      return 'Connecting...'
    case ConnectionState.proxy:
      return 'Connecting to proxy...'
    case ConnectionState.updating:
      return 'Updating...'
    case ConnectionState.network:
      return 'Waiting for networking...'
    default:
      return 'Updating...'
  }
}
